// Equals to the "ElementGroupNameCode" on BE side
export var EElementGroup;
(function (EElementGroup) {
    EElementGroup["DebugGroup"] = "DebugGroup";
    EElementGroup["FlowsGroup"] = "FlowsGroup";
    EElementGroup["HeatTransferGroup"] = "HeatTransferGroup";
    EElementGroup["PressureChangeGroup"] = "PressureChangeGroup";
    EElementGroup["PipelineGroup"] = "PipelineGroup";
    EElementGroup["CapacitiveDevicesGroup"] = "CapacitiveDevicesGroup";
    EElementGroup["ColumnDevicesGroup"] = "ColumnDevicesGroup";
    EElementGroup["ReactorDevicesGroup"] = "ReactorDevicesGroup";
    EElementGroup["CatalyticProcessesGroup"] = "CatalyticProcessesGroup";
    EElementGroup["HydroProcessesGroup"] = "HydroProcessesGroup";
    EElementGroup["ThermalProcessesGroup"] = "ThermalProcessesGroup";
    EElementGroup["SyntheticElementsGroup"] = "SyntheticElementsGroup"; // Синтетические элементы
})(EElementGroup || (EElementGroup = {}));
// Equals to the "ElementClassName" on BE side
export var EElement;
(function (EElement) {
    EElement["AbsorberElement"] = "AbsorberElement";
    EElement["MaterialFlowElement"] = "MaterialFlowElement";
    EElement["EnergyFlowElement"] = "EnergyFlowElement";
    EElement["CokerElement"] = "CokerElement";
    EElement["CokerReactorBlockElement"] = "CokerReactorBlockElement";
    EElement["CoolerElement"] = "CoolerElement";
    EElement["DieselFuelHydrotreatingElement"] = "DieselFuelHydrotreatingElement";
    EElement["DieselFuelHydrotreatingReactorBlockElement"] = "DieselFuelHydrotreatingReactorBlockElement";
    EElement["HeaterElement"] = "HeaterElement";
    EElement["HeatExchangerElement"] = "HeatExchangerElement";
    EElement["CompressorElement"] = "CompressorElement";
    EElement["ValveElement"] = "ValveElement";
    EElement["PumpElement"] = "PumpElement";
    EElement["WaterJetPumpElement"] = "WaterJetPumpElement";
    EElement["MixerElement"] = "MixerElement";
    EElement["PipelineElement"] = "PipelineElement";
    EElement["TwoPhaseSeparatorElement"] = "TwoPhaseSeparatorElement";
    EElement["ThreePhaseSeparatorElement"] = "ThreePhaseSeparatorElement";
    EElement["FractionatorElement"] = "FractionatorElement";
    EElement["CatCrackingElement"] = "CatCrackingElement";
    EElement["CatCrackingReactorRegeneratorBlockElement"] = "CatCrackingReactorRegeneratorBlockElement";
    EElement["CatReformingElement"] = "CatReformingElement";
    EElement["CatReformingReactorBlockElement"] = "CatReformingReactorBlockElement";
    EElement["DistillationColumnWithReboilerAndCapacitorElement"] = "DistillationColumnWithReboilerAndCapacitorElement";
    EElement["DetanderElement"] = "DetanderElement";
    EElement["SplitterElement"] = "SplitterElement";
    EElement["ComponentSplitterElement"] = "ComponentSplitterElement";
    EElement["ConversionReactorElement"] = "ConversionReactorElement";
    EElement["EquilibriumReactorElement"] = "EquilibriumReactorElement";
    EElement["HeatExchangerSynthetic"] = "HeatExchangerSynthetic";
    EElement["MultiStepCoherent"] = "MultiStepCoherent";
    EElement["MultiStepExternal"] = "MultiStepExternal";
    EElement["Balancer"] = "Balancer";
    EElement["EngineTestSynthetic"] = "EngineTestSynthetic";
    EElement["SingleParamChangeElement"] = "SingleParamChangeElement"; // ???
})(EElement || (EElement = {}));
// Equals to the "LogicalElementType" on BE side
export var ELogicalElement;
(function (ELogicalElement) {
    ELogicalElement["Recycle"] = "recycle";
    ELogicalElement["Function"] = "function";
    ELogicalElement["Optimization"] = "optimization";
    ELogicalElement["Cutter"] = "cutter";
    ELogicalElement["Set"] = "set";
})(ELogicalElement || (ELogicalElement = {}));
export var EPipelineSegment;
(function (EPipelineSegment) {
    /** Соединительные элементы трубопроводов **/
    EPipelineSegment["Pipe"] = "pipe";
    EPipelineSegment["CouplingUnion"] = "couplingUnion";
    EPipelineSegment["TeeElbow"] = "teeElbow";
    EPipelineSegment["TeeBranchBlanked"] = "teeBranchBlanked";
    EPipelineSegment["Swage45Degree"] = "swage45Degree";
    EPipelineSegment["SwageAbrupt"] = "swageAbrupt";
    /** Повороты и отводы трубопроводов **/
    EPipelineSegment["Bend90_RD1"] = "bend90_RD1";
    EPipelineSegment["Bend90_RD1_5"] = "bend90_RD1_5";
    EPipelineSegment["Bend90_RD2"] = "bend90_RD2";
    EPipelineSegment["Bend90_RD3"] = "bend90_RD3";
    EPipelineSegment["Bend90_RD4"] = "bend90_RD4";
    EPipelineSegment["Bend90_RD6"] = "bend90_RD6";
    EPipelineSegment["Bend90_RD8"] = "bend90_RD8";
    EPipelineSegment["Bend90_RD10"] = "bend90_RD10";
    EPipelineSegment["Bend90_RD12"] = "bend90_RD12";
    EPipelineSegment["Bend90_RD14"] = "bend90_RD14";
    EPipelineSegment["Bend90_RD16"] = "bend90_RD16";
    EPipelineSegment["Bend90_RD20"] = "bend90_RD20";
    EPipelineSegment["Elbow45Long"] = "elbow45Long";
    EPipelineSegment["Elbow45Mitre"] = "elbow45Mitre";
    EPipelineSegment["Elbow45Std"] = "elbow45Std";
    EPipelineSegment["Elbow90Long"] = "elbow90Long";
    EPipelineSegment["Elbow90Mitre"] = "elbow90Mitre";
    EPipelineSegment["Elbow90Std"] = "elbow90Std";
    EPipelineSegment["Degree180CloseReturn"] = "degree180CloseReturn";
    /** Запорная и регулирующая арматура **/
    EPipelineSegment["AngleValve45Open"] = "angleValve45Open";
    EPipelineSegment["AngleValve90Open"] = "angleValve90Open";
    EPipelineSegment["AngleValveOpen"] = "angleValveOpen";
    EPipelineSegment["BallValveOpen"] = "ballValveOpen";
    EPipelineSegment["ButterflyValve2_8InOpen"] = "butterflyValve2_8InOpen";
    EPipelineSegment["ButterflyValve10_14InOpen"] = "butterflyValve10_14InOpen";
    EPipelineSegment["ButterflyValve16_24InOpen"] = "butterflyValve16_24InOpen";
    EPipelineSegment["ButterflyValveAngle5"] = "butterflyValveAngle5";
    EPipelineSegment["ButterflyValveAngle10"] = "butterflyValveAngle10";
    EPipelineSegment["ButterflyValveAngle20"] = "butterflyValveAngle20";
    EPipelineSegment["ButterflyValveAngle40"] = "butterflyValveAngle40";
    EPipelineSegment["ButterflyValveAngle60"] = "butterflyValveAngle60";
    EPipelineSegment["CheckValveBall"] = "checkValveBall";
    EPipelineSegment["CheckValveDisk"] = "checkValveDisk";
    EPipelineSegment["CheckValveLift"] = "checkValveLift";
    EPipelineSegment["CheckValve45Lift"] = "checkValve45Lift";
    EPipelineSegment["CheckValveSwing"] = "checkValveSwing";
    EPipelineSegment["GateValveCraneOpen"] = "gateValveCraneOpen";
    EPipelineSegment["GateValveOneQuarter"] = "gateValveOneQuarter";
    EPipelineSegment["GateValveHalf"] = "gateValveHalf";
    EPipelineSegment["GateValveThreeQuarter"] = "gateValveThreeQuarter";
    EPipelineSegment["GateValveOpen"] = "gateValveOpen";
    EPipelineSegment["GlobeValveCraneOpen"] = "globeValveCraneOpen";
    EPipelineSegment["GlobeValveHalf"] = "globeValveHalf";
    EPipelineSegment["GlobeValveOpen"] = "globeValveOpen";
    EPipelineSegment["PlugCockAngle5"] = "plugCockAngle5";
    EPipelineSegment["PlugCockAngle10"] = "plugCockAngle10";
    EPipelineSegment["PlugCockAngle20"] = "plugCockAngle20";
    EPipelineSegment["PlugCockAngle40"] = "plugCockAngle40";
    EPipelineSegment["PlugCockAngle60"] = "plugCockAngle60";
    EPipelineSegment["PlugCockOpen"] = "plugCockOpen";
    EPipelineSegment["BlowoffValveOpen"] = "blowoffValveOpen";
    EPipelineSegment["DiaphragmValveOneQuarter"] = "diaphragmValveOneQuarter";
    EPipelineSegment["DiaphragmValveHalf"] = "diaphragmValveHalf";
    EPipelineSegment["DiaphragmValveThreeQuarter"] = "diaphragmValveThreeQuarter";
    EPipelineSegment["DiaphragmValveOpen"] = "diaphragmValveOpen";
    EPipelineSegment["FootValve"] = "footValve";
    EPipelineSegment["FootValveHingedDisk"] = "footValveHingedDisk";
    EPipelineSegment["FootValvePoppetDisk"] = "footValvePoppetDisk";
    /** Приборы учёта и контроля **/
    EPipelineSegment["WaterMeterDisk"] = "waterMeterDisk";
    EPipelineSegment["WaterMeterPiston"] = "waterMeterPiston";
    EPipelineSegment["WaterMeterRotary"] = "waterMeterRotary";
    EPipelineSegment["WaterMeterTurbine"] = "waterMeterTurbine"; // Водосчётчик турбинный
})(EPipelineSegment || (EPipelineSegment = {}));
export var EPipelineGroupSegment;
(function (EPipelineGroupSegment) {
    EPipelineGroupSegment["Pipe"] = "pipe";
    EPipelineGroupSegment["Bend"] = "bend";
    EPipelineGroupSegment["Valve"] = "valve";
    EPipelineGroupSegment["WaterMeter"] = "waterMeter"; // Приборы учёта и контроля
})(EPipelineGroupSegment || (EPipelineGroupSegment = {}));
//# sourceMappingURL=element.enum.js.map